import { CButton, CSpinner } from "@coreui/react";

const ExportToExcelButton = (props) => {
  //const [isExporting, setIsExporting] = useState(false);
  //isExporting, usersData, ExportToExcel

  return (
    <>
      {props.isExporting === false ? (
        <CButton
          color="success"
          disabled={props.isDisabled}
          onClick={() => {
            props.ExportToExcel();
          }}
        >
          Export To Excel
        </CButton>
      ) : (
        <CButton color="success" disabled>
          <CSpinner as="span" size="sm" aria-hidden="true" />
          &nbsp;Exporting Data...
        </CButton>
      )}
    </>
  );
};

export default ExportToExcelButton;
